import { ConvertConfig } from "@/components/pages/convert/hooks/use-start-convert";

import { ConvertSettings } from "@/components/pages/convert/providers/convert-provider";
import { ConvertBaseStorage } from "@/services/storage/base/convert-base-storage";
import { ConvertBaseSettingsField } from "@/services/storage/storage-mixins/settings-mixins/convert-base-settings-storage-mixin";
import { ConvertSettingsStorageMixin } from "@/services/storage/storage-mixins/settings-mixins/convert-settings-storage-mixin";

class ConvertSessionStorage extends ConvertBaseStorage<
  ConvertSettings,
  ConvertConfig,
  ConvertBaseSettingsField,
  ConvertSettingsStorageMixin
> {
  settingStorage: ConvertSettingsStorageMixin;

  constructor() {
    super("convertCache", "ConvertDB");

    this.settingStorage = new ConvertSettingsStorageMixin(
      this.storeName,
      this.databaseName,
    );
  }
}

const convertSessionStorage = new ConvertSessionStorage();
export { convertSessionStorage };
